import React from 'react';
import CardsGrid from "../components/CardsGrid";
import ScrollAnimatedDiv from "../components/ScrollAnimatedDiv"

const Home = () => {
    return (
        <div className='home'>
            <ScrollAnimatedDiv/>
            <section className="hero-section"></section>
            <h3>
                 –
            </h3>
            <CardsGrid/>
        </div>
    );
};

export default Home;
